<ags-extranet-header
  [userConnected]="userConnected"
  [signout]="signout"
  [userChange]="userChange"
  [themingClassName]="themingClassName">
</ags-extranet-header>
<div class="uk-grid uk-grid-collapse" style="height: calc(100vh - 56px)">
  <div class="uk-box-shadow-large uk-overflow-auto" style="height:100%; min-width: 36px; max-width: 250px">
    <ags-extranet-sidemenu
      [themingClassName]="themingClassName"
      [userChange]="userChange"
      [menu]="menu">
    </ags-extranet-sidemenu>
  </div>
  <div class="uk-width-expand uk-height-1-1 uk-overflow-auto">
    <router-outlet></router-outlet>
  </div>
</div>
